import { useEffect, useRef } from 'react'

import styles from './styles.module.scss'

const BillboardSection = (): JSX.Element => {
  const amountRef = useRef<HTMLDivElement>(null)
  const numberRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const amount = amountRef.current
    const number = numberRef.current
    if (!amount || !number) return

    const target = 100_000_000
    const format = (value: number) => value.toLocaleString('ja-JP')
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      typeof IntersectionObserver === 'undefined'
    ) {
      number.textContent = format(target)
      return
    }

    let animationFrame = 0
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return
        observer.unobserve(amount)
        const duration = 1100
        const start = performance.now()
        const tick = (now: number) => {
          const progress = Math.min(1, (now - start) / duration)
          number.textContent = format(Math.round(target * (1 - Math.pow(1 - progress, 3))))
          if (progress < 1) animationFrame = requestAnimationFrame(tick)
        }
        animationFrame = requestAnimationFrame(tick)
      },
      { threshold: 0.12 }
    )
    observer.observe(amount)
    return () => {
      observer.disconnect()
      cancelAnimationFrame(animationFrame)
    }
  }, [])

  return (
    <section className={`${styles.block} ${styles.billboard}`}>
      <div className={`${styles.content} ${styles.center}`}>
        <span className={`${styles.eyebrow} ${styles.reveal}`} data-reveal="">
          キャンペーン総額
        </span>
        <div className={`${styles.billboardLabel} ${styles.reveal}`} data-reveal="">
          総報酬
        </div>
        <div
          className={`${styles.billboardAmount} ${styles.reveal}`}
          data-reveal=""
          ref={amountRef}
        >
          <span className={styles.billboardYen}>¥</span>
          <span className={styles.billboardNumber} ref={numberRef}>
            100,000,000
          </span>
        </div>
        <div className={`${styles.billboardOku} ${styles.reveal}`} data-reveal="">
          ＝ <b>1億円分</b>の報酬を、みんなで使い切ろう
        </div>
        <p className={`${styles.billboardLead} ${styles.reveal}`} data-reveal="">
          日本全国を「荷物を預けられる場所」で埋めるために、総額1億円分の報酬をご用意しました。紹介者に15,000円、導入店舗に10,000円。紹介できる件数に上限はありません。
        </p>
        <div className={`${styles.billboardChips} ${styles.reveal}`} data-reveal="">
          <div>
            <b>¥15,000</b>
            <span>紹介者への報酬／1件</span>
          </div>
          <div>
            <b>¥10,000</b>
            <span>サインボーナス／1店舗</span>
          </div>
          <div>
            <b>上限なし</b>
            <span>何件でも紹介OK</span>
          </div>
        </div>
        <p className={`${styles.billboardCount} ${styles.reveal}`} data-reveal="">
          予算がなくなり次第、キャンペーンは終了となります。さあ、今すぐ。
        </p>
      </div>
    </section>
  )
}

export default BillboardSection
